import { render } from "./terBid.vue?vue&type=template&id=25f722e6"
import script from "./terBid.vue?vue&type=script&lang=js"
export * from "./terBid.vue?vue&type=script&lang=js"

import "./terBid.vue?vue&type=style&index=0&id=25f722e6&lang=scss"

import exportComponent from "/Users/a/Desktop/app/pulizhenkong_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__